import { removeNumberFromArray } from '@/util/utils'

export const state = () => {
  return {
    activeHover: [],
    dragOverNode: null,
  }
}

export const mutations = {
  add(state, id) {
    if (!state.activeHover.includes(id)) {
      state.activeHover.push(id)
    }
  },
  remove(state, id) {
    removeNumberFromArray(state.activeHover, id)
  },
  setDragOverNode(state, node) {
    state.dragOverNode = node
  }
}
